import PropTypes from 'prop-types';
import React from 'react';
import Moment from 'moment';

import Classes from 'classnames';
import InputInlineEditable from "../../../../../gd-components/input-inline-editable/input-inline-editable";

export default class FilterFormNumber extends React.Component {

    static propTypes = {
        filter: PropTypes.object.isRequired,         // link to filter instance
        min: PropTypes.number,
        max: PropTypes.number
    };

    constructor(props) {
        super(props);
    }

    normalizeValue(value) {
        if (!_.isNil(this.props.min) && value<this.props.min) value = this.props.min;
        if (!_.isNil(this.props.max) && value>this.props.max) value = this.props.max;

        return value;
    }

    onNoValueClick = () => {
        const curValue = this.props.filter.getValue();
        curValue.noValue = !curValue.noValue;
        this.props.filter.setValue(curValue, false);
        this.setState({reRender: true});
    };

    switchOption = (option)=>{
        const curValue = this.props.filter.getValue();
        curValue.curOption = option;
        this.props.filter.setValue(curValue, false);
        this.setState({reRender: true});
    };

    setGreaterThan = (value) => {
        const curValue = this.props.filter.getValue();

        value = this.normalizeValue(value);

        if (value) curValue.greaterThan = value;
        this.props.filter.setValue(curValue, false);
        this.setState({reRender: true});
    };

    setLessThan = (value) => {
        const curValue = this.props.filter.getValue();
        value = this.normalizeValue(value);
        curValue.lessThan = value;
        this.props.filter.setValue(curValue, false);
        this.setState({reRender: true});
    };

    // setBetween = (dateRange) => {
    //     const curValue = this.props.filter.getValue();
    //
    //     if (dateRange && dateRange.start) {
    //         // do nothing
    //     } else {
    //         dateRange = Moment.range(Moment().subtract(2,'weeks'), Moment().add(1,'month'));
    //     }
    //
    //     curValue.curOption = 'range';
    //     curValue.date = dateRange;
    //
    //     this.props.filter.setValue(curValue, false);
    //
    //     this.setState({reRender: true});
    // };

    render() {

        const curValue = this.props.filter.getValue();
        const {curOption, noValue, greaterThan, lessThan} = curValue;

        return (
            <div className="block-content filter-multiselect">

                <div className={Classes("type-option")} onClick={this.onNoValueClick}>
                    <div className={Classes('gd-cb-12',{selected: noValue})}> </div>

                    <div className="name">
                        {this.props.filter.noValueLabel}
                    </div>
                    <div className="cf"> </div>
                </div>

                <div className={Classes("type-option")} onClick={this.switchOption.bind(this, 'greater')}>
                    <div className={Classes('gd-radio',{selected: (curOption=='greater') })}> </div>
                    <div className="name">Greater than</div>
                    {curOption=='greater' && <InputInlineEditable type="number" className="size-30" value={greaterThan} formSize={30} onChange={this.setGreaterThan} />}
                    <div className="cf"> </div>
                </div>

                <div className={Classes("type-option")} onClick={this.switchOption.bind(this, 'less')}>
                    <div className={Classes('gd-radio',{selected: (curOption=='less') })}> </div>
                    <div className="name">Less than</div>
                    {curOption=='less' &&  <InputInlineEditable type="number" className="size-30"  value={lessThan} formSize={30} onChange={this.setLessThan} /> }
                    <div className="cf"> </div>
                </div>

                <div className={Classes("type-option")} onClick={this.switchOption.bind(this, 'between')}>
                    <div className={Classes('gd-radio',{selected: (curOption=='between') })}> </div>
                    <div className="name">Between</div>
                    {curOption=='between' && <div className="range">
                        <InputInlineEditable type="number" className="size-30" value={greaterThan} formSize={30} onChange={this.setGreaterThan} />
                        <div className="separator">-</div>
                        <InputInlineEditable type="number" className="size-30"  value={lessThan} formSize={30} onChange={this.setLessThan} />
                    </div>}
                    <div className="cf"> </div>
                </div>

            </div>
        );
    }
}